@use "@fukuri-admins/ui/layout" as *;

.root {
  padding: spacing('12') spacing('4');
}

.message {
  @include typography('Jp/14_W3');
  color: text('Low');
}
